module.exports = __webpack_public_path__ + "img/prescription2.b47b8fb8.png";